<template>
  <div class="home">
    <HomeTitle/>
    <HomeFunction/>
    <HomeInternational/>
    <HomeSafety/>
  </div>
</template>

<script>
import HomeTitle from './subcomponents/HomeTitle'
import HomeFunction from './subcomponents/HomeFunction'
import HomeInternational from './subcomponents/HomeInternational'
import HomeSafety from './subcomponents/HomeSafety'

export default {
  name: 'Home',
  components: {
    HomeTitle,
    HomeFunction,
    HomeInternational,
    HomeSafety
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue